import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 20px;

  > button:first-child {
    margin-right: 14px;
    margin-left: auto;
  }
`;
